// extracted by mini-css-extract-plugin
export default {"appRoot":"app_appRoot__RsygK"};